module.exports = __webpack_public_path__ + "b4e003d1f6bcf2e40ac9d26f1496cdaf.png";